module.exports = __webpack_public_path__ + "img/request.c023d9d9.jpg";